var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_976_8912)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1225 13.8875L19.2982 15.5787C19.4762 15.776 19.5932 16.0206 19.6352 16.2829C19.6771 16.5453 19.6422 16.8141 19.5345 17.057C19.4269 17.2999 19.2512 17.5065 19.0287 17.6516C18.8062 17.7968 18.5463 17.8744 18.2807 17.875H14.3688C14.211 18.6521 13.7894 19.3507 13.1755 19.8525C12.5615 20.3543 11.793 20.6284 11 20.6284C10.2071 20.6284 9.43856 20.3543 8.82461 19.8525C8.21067 19.3507 7.78908 18.6521 7.63129 17.875H3.71941C3.45373 17.8744 3.19392 17.7968 2.9714 17.6516C2.74888 17.5065 2.57318 17.2999 2.46555 17.057C2.35791 16.8141 2.32296 16.5453 2.3649 16.2829C2.40685 16.0206 2.52391 15.776 2.70191 15.5787L3.87754 13.8875C4.03802 13.6576 4.12438 13.3841 4.12504 13.1037V8.25C4.12504 6.42664 4.84937 4.67795 6.13868 3.38864C7.42799 2.09933 9.17668 1.375 11 1.375C12.8234 1.375 14.5721 2.09933 15.8614 3.38864C17.1507 4.67795 17.875 6.42664 17.875 8.25V13.1037C17.8757 13.3841 17.9621 13.6576 18.1225 13.8875ZM9.81268 18.8699C10.1598 19.116 10.5745 19.2488 11 19.25C11.4256 19.2488 11.8403 19.116 12.1874 18.8699C12.5345 18.6237 12.7969 18.2762 12.9388 17.875H9.06129C9.20313 18.2762 9.46559 18.6237 9.81268 18.8699ZM3.80191 16.4037C3.77817 16.4389 3.75049 16.4712 3.71941 16.5H18.2807C18.2496 16.4712 18.2219 16.4389 18.1982 16.4037L16.995 14.6712C16.6741 14.2114 16.5014 13.6645 16.5 13.1037V8.25C16.5 6.79131 15.9206 5.39236 14.8891 4.36091C13.8577 3.32946 12.4587 2.75 11 2.75C9.54135 2.75 8.1424 3.32946 7.11095 4.36091C6.0795 5.39236 5.50004 6.79131 5.50004 8.25V13.1037C5.49871 13.6645 5.32599 14.2114 5.00504 14.6712L3.80191 16.4037Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.4,
    cy: 4.4,
    r: 4.4,
    fill: "#FD0606"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_976_8912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotBellIcon);
export default __webpack_public_path__ + "static/media/dot-bell-icon.0c4397bd39ba5fb8694db9687af95e09.svg";
export { ForwardRef as ReactComponent };